/**
 * 工单来源
 */
export default function workOrderSource(val) {
    let str = '';
    switch (val) {
    case 'ADMIN':
        str = '直接创建';
        break;
    case 'BOOKING_ORDER':
        str = '预约订单';
        break;
    case 'ACCIDENT_CLUE':
        str = '碰撞救援线索';
        break;
    case 'MAINTAIN_CLUE':
        str = '保养线索';
        break;
    default:
        break;
    }
    return str;
}
